import React from "react";
import ImageLoading from "./ImageLoading";

function DownloadLoadingModal() {
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[360px]  !justify-normal  relative !p-0 !text-left !items-center !h-[130px] `}
      >
        <div className=" w-full h-full flex justify-center items-center">
          <ImageLoading />
        </div>
      </div>
    </div>
  );
}

export default DownloadLoadingModal;
